/**
 * Which surface a payment was taken on.
 *
 * Derived from `terminalId` rather than `source`: the only writer of
 * `terminalId` is the Poynt/FreePay handler, so its presence is the terminal
 * by construction. `source` describes the origin system (`stripe_connected`,
 * `ch_dest`) and says nothing about the device.
 */
export type Platform = "app" | "terminal";

export const PLATFORMS: Platform[] = ["app", "terminal"];

const LABELS = new Map<Platform, string>([
  ["app", "App"],
  ["terminal", "Terminal"],
]);

export function platformLabel(platform: Platform): string {
  return LABELS.get(platform) ?? platform;
}

export function transactionPlatform(tx: {
  terminalId?: string | null;
}): Platform {
  return tx.terminalId ? "terminal" : "app";
}

/**
 * Deliberately neither green nor red: those read as status, and a payment
 * taken on the terminal is neither better nor worse than one in the app.
 */
const STYLES = new Map<Platform, string>([
  ["app", "bg-sky-50 text-sky-700 ring-sky-200"],
  ["terminal", "bg-violet-50 text-violet-700 ring-violet-200"],
]);

export function platformStyle(platform: Platform): string {
  return STYLES.get(platform) ?? "";
}
